import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@env';
import { translate } from '@ngneat/transloco';
import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';
import { getSelectedRestApiName$ } from '../../store/selectors/master-management.selector';
import { PaginationInterface } from '../../interface/pagination.interface';
import { TableColumn } from '../../interface/table-column.interface';
import { TableData } from '../../interface/table-data.interface';
import { Transformation } from '../../models/transformation';

import {
    allTableColumns,
    eventTypesList,
    filingAttributes,
    notificationPagination,
    notificationTableData,
    transformations,
} from '../../../../custom/components/apps-page/mock-data';

@Component({
    selector: 'app-all-process-action-dialog',
    templateUrl: './all-process-action-dialog.component.html',
    styleUrls: ['./all-process-action-dialog.component.scss'],
    standalone: false,
})
export class AllProcessActionDialogComponent {
    @Input() public dailogTitle: string;
    @Input() public record: string;
    @Input() public showingInstanceAttributes = false;
    @Input() public showingInstanceStatus = false;
    @Input() public showingNotifications = false;
    @Input() public showingProcessesUploadFiles = false;
    @Input() public metaData;

    public restApiName: string;
    public filingAttributes = filingAttributes;
    public checkPrecaptureField = false;
    public integrationStatus = 'Not Applicable';
    public eventTypesList: { id: string; displayName: string }[] = eventTypesList;
    public selectedEventType = '';
    public allAssetsName = '';
    public openProcessLogs: () => void;
    public allTableColumns: BehaviorSubject<TableColumn[]> = new BehaviorSubject([]);
    public tableData: BehaviorSubject<TableData[]> = new BehaviorSubject([]);
    public selectedColumns: string[] = ['createdOn', 'eventType', 'displayDetail', 'displayActions'];
    public pagination: BehaviorSubject<PaginationInterface> = new BehaviorSubject({
        size: 5,
        count: 0,
        pageIndex: 0,
        page: 0,
        pages: [],
        disableNext: true,
    });
    public transformations: {
        orgName: string;
        transformations: Transformation[];
        repositoryId: string;
    }[] = transformations as any;
    public selectedTransformationName: string;
    public transformationErrors = [];
    private transformationSources = [];
    // private selectedRepositoryTransformations: any;
    public sourceTableData = new BehaviorSubject([]);
    public sourceTableColumns = [
        {
            name: 'name',
            displayName: translate('Source Name'),
            show: true,
            type: 'text',
        },
        {
            name: 'sourceDataFormat',
            displayName: translate('Supported Format'),
            show: true,
            type: 'text',
        },
        {
            name: 'from',
            displayName: translate('Choose File'),
            show: true,
            type: 'file',
        },
        {
            name: 'downloadSourceTemplate',
            displayName: translate('Download Source Template'),
            show: true,
            type: 'link',
        },
    ];
    public hidePaginator = true;
    public primaryColumns = ['Source Name', 'Supported Format'];

    constructor(private dialog: MatDialog, private store: Store<any>) {}

    public trackByMethod(_index: number, item: any): any {
        return item.displayName;
    }

    public changeTextColor = status => {
        if (status === 'Not Applicable' || status === 'Failed') {
            return '!text-red-500';
        } else if (status === 'Completed' || status === 'In-Progress') {
            return '!text-green-500';
        }
    };

    public getAllNotifications = () => {};

    public refreshItemsWithNewPageSize = _$event => {};

    public fetchItemsInPage = _$event => {};

    public getSelectedTransformation = () => {
        this.transformationSources = [];
        if (this.selectedTransformationName && this.selectedTransformationName.length > 0) {
            for (let i = 0; i < this.transformations.length; i++) {
                for (let j = 0; j < this.transformations[i].transformations.length; j++) {
                    if (this.selectedTransformationName === this.transformations[i].transformations[j].id) {
                        // this.selectedRepositoryTransformations = this.transformations[i];
                        this.transformationSources = this.transformations[i].transformations[j].sourceParts;
                    }
                }
            }
        }
        this.buildTableData();
    };

    public downloadSourceTemplateUrl = data => {
        const url =
            `${environment['taxilla_api']}/v2/services/${encodeURIComponent(this.restApiName)}/user-template` +
            `?transformationName=${encodeURIComponent(this.selectedTransformationName)}` +
            `&sourceName=${encodeURIComponent(data.name)}`;
        location.href = url;
    };

    public validateUploadProcessesData = () => {};

    private buildTableData = () => {
        this.sourceTableData.next(this.transformationSources);
    };

    public refreshProcessLogs = () => {};

    trackEventType(_index: number, eventType: any): any {
        return eventType.id;
    }

    closeModal = () => {
        this.dialog.closeAll();
    };

    translateMsg = (msg: string): string => translate(msg);

    ngOnInit(): void {
        this.tableData.next(notificationTableData);
        this.allTableColumns.next(allTableColumns as TableColumn[]);
        this.pagination.next(notificationPagination);
        this.store.select(getSelectedRestApiName$).subscribe(restApiName => {
            this.restApiName = restApiName;
        });
    }
}
